import type { FetchThemePageProps } from '~/types/themePage';

import { useQueryThemePagesPaginated } from './useQueryThemePagesPaginated';
import { useTemplateIdParser } from '~/modules/campaign-template';
import { useQueryThemeInfo } from './useQueryThemeInfo';
import { useMemo } from 'react';

export const useQueryThemePagesV7 = (props?: FetchThemePageProps) => {
  const { themeId } = useQueryThemeInfo();
  const { templateIdWithVariant, templateIdWithAsset } = useTemplateIdParser(props);

  const templateIds = useMemo(() => {
    if (props?.assets) {
      return templateIdWithAsset;
    }

    if (props?.campaigns) {
      return templateIdWithVariant;
    }
    return [];
  }, [props?.assets, props?.campaigns, templateIdWithAsset, templateIdWithVariant]);

  useQueryThemePagesPaginated(themeId, templateIds);
};
